import React, { useEffect } from 'react';
import { useFormService, FORM_EVENTS } from '@bingads-webui-react/form-core';
import {
  mergeClasses,
  makeStyles,
} from '@fluentui/react-components';
import {
  DrawerBody,
  DrawerHeader,
  DrawerFooter,
  Drawer,
} from '@fluentui/react-drawer';

const useDrawerTemplateStyles = makeStyles({
  drawerLayout: {},
});

interface DrawerTemplateProps {
  items: {
    Blocker: React.FC;
    TitleBar: React.FC;
    Content: React.FC;
    Footer: React.FC;
    CancelDialog: React.FC;
    ConfirmDialog: React.FC;
  };
  isOpen: boolean;
  className?: string;
}

export const DrawerTemplate: React.FC<DrawerTemplateProps> = ({
  items, isOpen, className, ...restProps
}) => {
  const {
    Blocker = React.Fragment,
    TitleBar,
    Content,
    Footer,
    CancelDialog,
    ConfirmDialog,
  } = items;
  const classes = useDrawerTemplateStyles();
  const { send } = useFormService();

  useEffect(() => {
    if (isOpen) {
      send(FORM_EVENTS.LOAD);
    }
  }, [isOpen, send]);

  return (
    <Drawer
      className={mergeClasses('drawer-layout', classes.drawerLayout, className)}
      open={isOpen}
      modalType="alert"
      position="end"
      {...restProps}
    >
      {TitleBar
        && (
        <DrawerHeader>
          <TitleBar />
        </DrawerHeader>
        )}
      <DrawerBody>
        <Blocker>
          <Content />
          {CancelDialog && <CancelDialog />}
          {ConfirmDialog && <ConfirmDialog />}
        </Blocker>
      </DrawerBody>
      {Footer
        && (
        <DrawerFooter>
          <Footer />
        </DrawerFooter>
        )}
    </Drawer>
  );
};
